import { createGlobalStyle } from 'styled-components';
import { colorPalette, typography } from 'stylesheet';

// We are resetting base HTML styles, using HTML tags is OK here
// stylelint-disable
const CSSResets = createGlobalStyle`
    /* This is the Eric Meyer reset: https://cssreset.com/scripts/eric-meyer-reset-css/ */
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    /* This is our custom rules, they are here because most project need them */
    * {
        box-sizing: border-box;
    }
    html {
        height: 100%;
        ${typography.main}
        color: ${colorPalette.greyDark};
    }
    body, #root {
        height: 100%;
        overflow: hidden;
    }
    input {
        border: none;
        outline: none;
    }
    #__next{
      height:100%;
    }
`;

export default CSSResets;
